import { Box } from "@material-ui/core";
import { AdministratorsPage } from "administrators/AdministratorsPage";
import { ApplicationConfigPage } from "application-config/ApplicationConfigPage";
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { SynchStatusPage } from "../administration.synchstatus/SynchStatusPage";
import { CustomersPage } from "../customers/CustomersPage";
import { EMsPage } from "../ems/EMsPage";
import { EngineersPage } from "../engineers/EngineersPage";
import { PluginSettingsPage } from "../plugins/PluginSettingsPage";
import { PluginsPage } from "../plugins/PluginsPage";
import { RegionsPage } from "../regions/RegionsPage";
import { TeamsPage } from "../teams/TeamsPage";

export function AdministrationPage() {
  return (
    <Box>
      <Switch>
        <Route path="/administration/settings">
          <ApplicationConfigPage />
        </Route>
        <Route path="/administration/plugins/:pluginKey">
          <PluginSettingsPage />
        </Route>
        <Route path="/administration/plugins">
          <PluginsPage />
        </Route>
        <Route path="/administration/administrators">
          <AdministratorsPage />
        </Route>
        <Route path="/administration/customers">
          <CustomersPage />
        </Route>
        <Route path="/administration/teams">
          <TeamsPage />
        </Route>
        <Route path="/administration/ems">
          <EMsPage />
        </Route>
        <Route path="/administration/engineers">
          <EngineersPage />
        </Route>
        <Route path="/administration/regions">
          <RegionsPage />
        </Route>
        <Route path="/administration/synchstatus">
          <SynchStatusPage />
        </Route>
        <Route path="/administration">
          <Redirect to="/administration/customers" />
        </Route>
      </Switch>
    </Box>
  );
}
